import React, { useState } from 'react';
import api from '../../api';
import { FaLock, FaKey, FaCheckCircle } from 'react-icons/fa';
// Import CSS Module
import styles from './Admin.module.css';

const AdminSettings = () => {
  const [passwords, setPasswords] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [message, setMessage] = useState({ text: '', type: '' });
  const [loading, setLoading] = useState(false);



  const handleChange = (e) => {
    setPasswords({ ...passwords, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage({ text: '', type: '' });

    // 1. Validation
    if (passwords.newPassword !== passwords.confirmPassword) {
      setMessage({ text: "New passwords do not match!", type: "error" });
      return;
    }
    if (passwords.newPassword.length < 6) {
      setMessage({ text: "Password must be at least 6 characters.", type: "error" });
      return;
    }

    setLoading(true);
  

    try {
      // 2. API Call
     await api.post('/auth/change-password', {
  oldPassword: passwords.oldPassword,
  newPassword: passwords.newPassword
});

      setMessage({ text: "Password Changed Successfully!", type: "success" });
      setPasswords({ oldPassword: '', newPassword: '', confirmPassword: '' });

    } catch (err) {
      // Error Handling
      const errorMsg = err.response?.data || "Failed to update password.";
      setMessage({ text: typeof errorMsg === 'string' ? errorMsg : "Failed to update password.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {/* Container using formCard style */}
      <div className={styles.formCard} style={{ maxWidth: '500px' }}>
        
        <h3 style={{ marginBottom: '1.5rem', color: '#4ade80', display: 'flex', alignItems: 'center', gap: '10px' }}>
          <FaLock /> Change Admin Password
        </h3>
        
        {/* Message Alert Box */}
        {message.text && (
          <div style={{
            padding: '12px', marginBottom: '20px', borderRadius: '8px',
            background: message.type === 'error' ? 'rgba(239, 68, 68, 0.15)' : 'rgba(74, 222, 128, 0.15)',
            color: message.type === 'error' ? '#fca5a5' : '#4ade80',
            border: message.type === 'error' ? '1px solid rgba(239, 68, 68, 0.3)' : '1px solid rgba(74, 222, 128, 0.3)',
            display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem'
          }}>
            {message.type === 'success' && <FaCheckCircle />}
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          
          <div className={styles.formGroup}>
            <label>Old Password</label>
            <input 
              type="password" 
              name="oldPassword" 
              value={passwords.oldPassword} 
              onChange={handleChange}
              className={styles.formInput} 
              placeholder="Enter current password"
              required 
            />
          </div>

          <div className={styles.formGroup}>
            <label>New Password</label>
            <input 
              type="password" 
              name="newPassword" 
              value={passwords.newPassword} 
              onChange={handleChange}
              className={styles.formInput}
              placeholder="Min 6 characters"
              required 
            />
          </div>

          <div className={styles.formGroup}>
            <label>Confirm New Password</label>
            <input 
              type="password" 
              name="confirmPassword" 
              value={passwords.confirmPassword} 
              onChange={handleChange}
              className={styles.formInput}
              placeholder="Re-enter new password"
              required 
            />
          </div>

          <button 
            type="submit" 
            className={styles.primaryBtn}
            disabled={loading}
            style={{ marginTop: '10px' }}
          >
            {loading ? 'Updating...' : <><FaKey /> Update Password</>}
          </button>
          
        </form>
      </div>
    </div>
  );
};

export default AdminSettings;